import { useMemo } from 'react'
import { Modal } from 'reactstrap'
import images from '../../../../api/images/hooks'
import Loader from '../../../Common/Loader'
import { useBlobUrls } from '../../../Hooks/useBlobUrl'
import { ShopWindowPrintModalProps } from '../types'
import ModalContent from './ModalContent'
import styles from './ShopWindowPrintModal.module.css'

const ShopWindowPrint = (props: ShopWindowPrintModalProps) => {
    const { isOpen, shopWindowPrintModal } = props
    const { properties, selectedTemplate } = shopWindowPrintModal ?? {}

    const photoIds = useMemo(() => properties?.flatMap((property) => property.photos), [properties])

    const photoUrlQueries = images.GetImagesByUrl.useQueries(photoIds || [], '')
    const blobUrls = useBlobUrls(photoUrlQueries)
    const allFetched = photoUrlQueries.every((q) => !q.isPending)

    const formattedProperties = useMemo(() => {
        if (!allFetched || !properties) return

        return properties.map((property) => ({
            ...property,
            photos: property.photos.map((photo) => {
                const photoIndex = photoIds.findIndex((p) => p.id === photo.id)

                return {
                    ...photo,
                    src: blobUrls[photoIndex],
                }
            }),
        }))
    }, [allFetched, properties, blobUrls, photoIds])

    const verticalTemplates = ['template-1', 'template-2', 'template-3', 'template-4']
    const isModalVertical = Boolean(selectedTemplate && verticalTemplates.includes(selectedTemplate))

    if (!formattedProperties) return <Loader />

    return (
        <Modal isOpen={isOpen} className={isModalVertical ? styles.modalVertical : styles.modalHorizontal} centered>
            <ModalContent properties={formattedProperties} selectedTemplate={selectedTemplate} isModalVertical={isModalVertical} />
        </Modal>
    )
}

export default ShopWindowPrint
